import { createContext, use, type ReactNode } from "react"

/*
 * A surface whose parts open no tooltip and no Toggletip: a Board's card, which a Member drags by
 * any part of it, the assignee's avatar included, where a tip opening and closing under the pointer
 * only gets in the way. Each part says what its tip said in its accessible name instead, and the
 * ticket's own page shows it all.
 */

const TipsShown = createContext(true)

/** Turns off the tooltips and Toggletips of every glyph, chip and avatar inside it. */
export function WithoutTips({ children }: { children: ReactNode }) {
  return <TipsShown value={false}>{children}</TipsShown>
}

/** Whether a part may open a tooltip or a Toggletip here: everywhere but inside `WithoutTips`. */
export function useTipsShown() {
  return use(TipsShown)
}
